import { ReactNode } from "react";
import { transformHtml } from "../../utils/CmsUtils";
import ContentSection from "../ContentSection";
import "./style.scss";

export const CockpitFaqItem = ({
  question,
  answer
}: {
  question: string;
  answer: string;
}) => {
  return (
    <li className="faq-item-detail">
      <h3>{question}</h3>
      <div className="faq-item-description">{transformHtml(answer)}</div>
    </li>
  );
};

export const CockpitFaqSection = ({
  heading,
  children
}: {
  heading: string;
  children: ReactNode;
}) => {
  return (
    <ContentSection className="cockpit-content_section">
      <div className="faq-section">
        <div className="cockpit-bjelin_heading">
          <h5>{heading}</h5>
        </div>
        <ul className="faq-items" style={{ margin: 0 }}>
          {children}
        </ul>
      </div>
    </ContentSection>
  );
};
